<template>



  <div id="scroll-div-ranked" class="main layer2" style="height: calc(100% - 2.5rem); padding-top: 2.5rem; overflow: auto;">

    <div>
        <ul class="serchlist">
          <!-- <li>
            <span v-for="(item, index) in category.publishStatusList" :key="item.code"
                  :class="{ active: getPublishActive === item.code}"
                  @click="changePublishStatus(item.code)">{{ item.desc }}</span>
          </li> -->
          <li>
            <span v-for="(item, index) in category.categoryList" :key="item.id"
                  :class="{ active: getCategoryActive === item.id }"
                  @click="categoryTab(item.id, 1)">{{ item.name }}</span>
          </li>
        </ul>
      </div>

    <swiper :ad-list="adList"></swiper>
    <books-small :show-title="false" :books="books.small"></books-small>
    <books-large :show-title="false" :books="books.large"></books-large>

    <button class="next-btn" v-if="nextPage" @click="categoryTab(selected.category, currentPage + 1 )">再来一批</button>

    <div v-if="isLoading" class="home-loading"></div>
    
  </div>
</template>

<script>
  import Swiper from '@/components/share/swiper'
  import BooksSmall from '@/components/share/books-small'
  import BooksLarge from '@/components/share/books-large'
  import Loading from "../../../components/share/loading";

  import listService from "../../../services/listService";

  export default {
    name: "day",
    data() {
      return {
        componentName: '',
        adList: [],
        books: {
          small: [],
          large: []
        },
        isLoading: false,
        isNoMoreData: false,
        currentPage: 1,

        category: {
          publishStatusList: [],
          categoryList: []
        },
        selected: {
          category: '0',
          publish: 'all'
        },
        pageSize: 10,
        nextPage: false,

      }
    },
    computed: {
      getPublishActive() {
        return this.selected.publish
      },
      getCategoryActive() {
        console.log(this.selected.category)
        return this.selected.category
      }
    },
    methods: {
      categoryTab(id, p){
        this.selected.category = id
        this.getBooks(p);
        
      },
      getCategory() {
        listService.getCategory()
          .then(res => {
            let c = {};
            c.publishStatusList = [{code: 'all', desc: '全部'}, ...res.data.publishStatusList];
            c.categoryList = [{id: '0', name: '全部'}, ...res.data.categoryList];
            this.category = c
          })
      },

      getBooks(target) {
        this.currentPage = target;
        
        if(target === 1) {
          this.books = {small: [], large: []}
        }else if(target === 6){
          this.nextPage = false;
          this.currentPage = 1
          return
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        let _category = this.selected.category
        if(this.selected.category === 0 || this.selected.category === '0' ){
          _category = ''
        }
        listService.getMoreDayUp(this.currentPage, _category, this.pageSize)
          .then(res => {
              this.isLoading = false;
              this.adList = res.data.adList;
              this.nextPage = res.data.bookList.length === 10 ? true : false;
              if (res.data.totalPage === 0) {
                this.isNoMoreData = true;
                this.books = {small: [], large: []}
              } else if (this.currentPage === 1) {
                let data = res.data.bookList;
                this.books.small = data.splice(0, 3);
                this.books.large = data;
              } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
                this.books.large.push(...res.data.bookList);
              }
              if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
                this.isNoMoreData = true;
              }
            })
      }

    },
    components: {
      swiper: Swiper,
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      loading: Loading
    },
    mounted() {
      this.componentName = this.$route.name;
      if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-ranked');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      } else {
        //this.adList = swiperService.getAdList();
        this.getCategory();
        this.getBooks(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-ranked');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>
  .next-btn{display: block;
    width: 90%;
    border-color: #124272;
    color: #124272;
    border: 0.1rem solid #124272;
    line-height: 1.6rem;
    height: 1.6rem;
    padding: 0;
    text-align: center;
    border-radius: 0.8rem;
    font-size: .8rem; display: block; margin: 0 auto; background: #fff;}
  
    .serchlist li span{ margin: 0 0.1rem 0.2rem 0.1rem;  text-align: center;font-size:.5rem; background: #e99d18; height: 1rem; line-height: 1rem; 
    border: 0px solid #083460; padding: 0rem 0.4rem; border-radius: 1rem; color: #fff;}
    .serchlist li span.active{ border: 1px solid #e99d18; background: #fff; color: #b97500;}
    .home-loading{position: absolute; background:#000 url(../../../assets/images/loading4.gif) center center no-repeat; background-size: 40px; top: 0px; left: 0; right: 0; bottom: 0; z-index: 500; opacity: .5;}

</style>



// WEBPACK FOOTER //
// src/pages/layer2/books/day.vue